'use client'

import { useCart } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import { ScrollArea } from '@/components/ui'
import { CartItem } from '@/components/molecules'
import { CartPlaceholder } from '@/components/placeholders'

interface CartItemsProps extends React.ComponentPropsWithoutRef<'div'> {
  focusBarcode?: () => void
}

export const CartItems = ({
  className,
  focusBarcode,
  ...restProps
}: CartItemsProps) => {
  const { cart } = useCart()

  if (!cart?.cart_items?.length)
    return (
      <div className="flex items-center justify-center rounded-lg bg-gray-50 lg:flex-grow">
        <CartPlaceholder />
      </div>
    )

  return (
    <ScrollArea
      className={cn('flex flex-grow flex-col lg:-mr-4 lg:pr-4', className)}
    >
      <div className={cn('flex w-full flex-col gap-2')} {...restProps}>
        {cart?.cart_items?.map((product: any) => (
          <CartItem product={product} key={product?.id} />
        ))}
      </div>
    </ScrollArea>
  )
}
